export default __webpack_public_path__ + "static/media/soc.2cb37f27.png";